import React, { useEffect, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import {
    Button,
    Container,
    Grid,
    UiDialog as Dialog,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';

import IcoPlans from 'resources/icoPlans.svg?react';

import * as actions from './actions';
import { ListItems, ProductForm } from './components';
import * as selectors from './selectors';

const SystemsContainer = ({
    initializeContainer,
    filterItems,
    handleClickBulkItems,
    handleClickCloseModalProduct,
    handleClickCreate,
    handleClickUpdate,
    handleSaveRow,
    isFetching,
    isNewRecord,
    isOpenModalProduct,
    items,
    paginationItems,
    roofTypesToSelect,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        initializeContainer(filterData);
    }, []);

    return (
        <Container maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon
                        icon={<IcoPlans height="24px" width="24px" />}
                        title={t('System', { count: 2 })}
                    />
                </Grid>
                <Grid textAlign="right">
                    <Button
                        onClick={() => handleClickCreate()}
                        startIcon={<AddIcon />}
                        sx={{ width: { md: 'auto', xs: '100%' } }}
                    >
                        {t('Add system')}
                    </Button>
                </Grid>
            </HeaderContainer>

            <ListItems
                filterData={filterData}
                filterItems={filterItems}
                handleClickBulkItems={handleClickBulkItems}
                handleClickUpdate={handleClickUpdate}
                handleSaveRow={handleSaveRow}
                isFetching={isFetching}
                items={items}
                paginationData={paginationItems}
                roofTypesToSelect={roofTypesToSelect}
                setFilterData={setFilterData}
            />

            <Dialog
                onClose={() => handleClickCloseModalProduct()}
                open={isOpenModalProduct}
                title={`${isNewRecord ? t('Create') : t('Update')} ${t(
                    'System',
                ).toLowerCase()}`}
            >
                <ProductForm
                    filterData={filterData}
                    handleClickCloseForm={handleClickCloseModalProduct}
                />
            </Dialog>
        </Container>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetching: selectors.getIsFetchingItems,
    isNewRecord: selectors.getIsNewRecord,
    isOpenModalProduct: selectors.getIsOpenModalProduct,
    items: selectors.getFetchItemsData,
    paginationItems: selectors.getFetchItemsPagination,
    roofTypesToSelect: selectors.getRoofTypesToSelect,
});

const mapDispatchToProps = (dispatch) => ({
    fetchRooftTypes: () => dispatch(actions.fetchRooftTypes()),
    filterItems: (filterData) => dispatch(actions.filterItems(filterData)),
    initializeContainer: (filterData) =>
        dispatch(actions.initializeContainer(filterData)),
    handleClickBulkItems: (ids, value, filterData, callback) =>
        dispatch(actions.prepareBulkItems(ids, value, filterData, callback)),
    handleClickCloseModalProduct: () => dispatch(actions.closeModalProduct()),
    handleClickCreate: (branchSelected) =>
        dispatch(actions.prepareCreate(branchSelected)),
    handleClickUpdate: (id) => dispatch(actions.fetchItem(id)),
    handleSaveRow: (item) => dispatch(actions.updatePlan(item)),
});

SystemsContainer.propTypes = {
    filterItems: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    handleClickCloseModalProduct: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    initializeContainer: PropTypes.func,
    isFetching: PropTypes.bool,
    isNewRecord: PropTypes.bool,
    isOpenModalProduct: PropTypes.bool,
    items: PropTypes.array,
    paginationItems: PropTypes.object,
    roofTypesToSelect: PropTypes.array,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    SystemsContainer,
);
